/**
 * Impact Reflection Lesson
 * Skill Area: Insight
 * Capture wins and adjustments for growth
 */

import type { LessonDefinition } from '../types';
import {
  IMPACT_REFLECTION_AI_PROMPT,
  IMPACT_REFLECTION_CONTEXT_SCENARIOS,
} from '../prompts/impact-reflection.prompt';

export const impactReflection: LessonDefinition = {
  id: 'impact-reflection',
  title: 'Impact Reflection',
  displayTitle: 'Capture Wins and Adjustments for Growth',
  subTitle: 'Note what felt right and adjust.',
  tagline: 'Pause, notice, adjust.',
  persona: 'Lyra',
  skillArea: 'Insight',
  format: 'reflection',
  difficulty: 'Beginner',
  estimatedMinutes: 5,
  tags: ['reflection', 'habits', 'clarity'],
  dailyEligible: true,
  releasedAt: '2025-02-10T00:00:00.000Z',
  route: '/micro/impact-reflection',
  storyBeat: 'Lyra keeps learning gentle and honest.',
  contextTitle: 'Reflection starters',
  contextSummary:
    "If you're not sure what to log, borrow one of these moments and see what Lyra surfaces.",
  contextScenarios: IMPACT_REFLECTION_CONTEXT_SCENARIOS,
  introPrompt:
    "Speed without learning is just busywork. I'll explain why reflection matters, show you a comparison, and helped you capture a simple log.",
  steps: [
    'Share a moment from today (Win or Watch-out)',
    'See a "Blur vs. Insight" comparison',
    'Log your Win, Watch-out, and Next Step',
  ],
  promptGuidance: 'Choose an option below or type your own.',
  aiPrompt: IMPACT_REFLECTION_AI_PROMPT,
  inputPlaceholder: "Type 'Win' or your own reflection...",
  quickPrompts: ['A Win (Saved Time)', 'A Watch-out (Risky)', 'A Wash (Confusing)'],
};
